import React, { useState } from 'react';
import { IconButton, Box, makeStyles, Typography } from '@material-ui/core';

import TagsAZ from 'tags/AZ';
import { useQuery } from 'react-fetching-library';
import { fetchWhatTags } from 'resources/api';

const useStyles = makeStyles(({ palette }) => ({
  button: {
    height: '54px',
    border: 'none',
    borderRadius: '100vh',
    backgroundColor: palette.secondary.light,
    padding: '12px 20px 12px 20px',
    outline: 'none',
  },
}));

const AZSearch = () => {
  const classes = useStyles();
  const { payload: payloadTags } = useQuery(fetchWhatTags);

  const [showPopup, setShowPopup] = useState(false);

  if (!payloadTags) return null;

  return (
    <>
      <Box display="flex" style={{ minWidth: '130px' }}>
        <IconButton className={classes.button} onClick={() => setShowPopup(true)}>
          <Typography>A-Z Search</Typography>
        </IconButton>
      </Box>
      {showPopup && <TagsAZ tags={payloadTags} action={() => setShowPopup(false)} />}
    </>
  );
};

export default AZSearch;
